
import React from 'react';
import { Message } from './types';
import ChatbotAvatar from './ChatbotAvatar';

interface ChatMessageProps {
  message: Message;
}

const formatTime = (date: Date) => {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isBot = message.sender === 'bot';
  
  return (
    <div className={`mb-4 flex ${isBot ? 'justify-start' : 'justify-end'}`}>
      {isBot && <ChatbotAvatar size="small" />}
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-2 ${
          isBot
            ? 'bg-gray-100 text-foreground rounded-tl-none'
            : 'bg-primary text-white rounded-tr-none'
        }`}
      >
        {/* Utilisez dangerouslySetInnerHTML pour afficher le contenu HTML */}
        {isBot ? (
          <div 
            className="text-sm chatbot-message" 
            dangerouslySetInnerHTML={{ __html: message.text }}
          />
        ) : (
          <p className="text-sm">{message.text}</p>
        )}
        
        <p className={`text-xs mt-1 ${
          isBot ? 'text-foreground/50' : 'text-white/70'
        }`}>
          {formatTime(message.timestamp)}
          {message.platform && message.platform !== 'web' && (
            <span className={`ml-2 px-1 rounded text-[10px] ${
              message.platform === 'telegram' 
                ? 'bg-blue-200 text-blue-700' 
                : 'bg-gray-200 text-gray-700'
            }`}>
              {message.platform}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};

export default ChatMessage;
